module.exports = __webpack_public_path__ + "static/media/forward_logo.023288d9.svg";